import BlackJackTableModel from "./blackjack_table_model";
import BlackJackTableView from "./blackjack_table_view";
import BlackJackTableLogic from "./blackjack_table_logic";
import Module, { moduleInit } from "../../../../framework/core/mvvm/module_base";


import { NetMsgBlackJack } from "../../net/net_msg_data_map_blackjack";
//import * as ProtoGame from "../../net/proto/blackjack/proto_balckjack_game"
const { ccclass } = cc._decorator;
import GameServer from "../../../hall/server/gameserver/game_server";
import NetMsgDataTableBase from "../../../table/net/net_msg_data_table_base";
import * as ProtoPokerRoom from "../../../table/net/proto/proto_poker_room";
import { BlackJack } from "../../net/proto/proto_blackjack_game";
import SceneManager from "../../../../manager/scene_manager";
import { joinUtil } from "../../../public/join_util";
import { Room } from "../../../table/net/proto/proto_poker_room";
import TableBaseModule from "../../../table/module/table_base/table_base_module";

@ccclass
@moduleInit("BlackJackTableModule")
export default class BlackJackTableModule<V extends BlackJackTableView, M extends BlackJackTableModel > extends TableBaseModule<V, M>  {
    genSeatInfo(playerId: any): import("../../../table/module/poker_table/poker_table_data_interface").ISeatStateData {
        throw new Error("Method not implemented.");
    }
    protected refreshMyCoinBalance(gold: number) {
        throw new Error("Method not implemented.");
    }
    protected mLogic: BlackJackTableLogic = null

   
    m_lastRefreshTime = 0
    constructor(){
        super();
        this.viewType = BlackJackTableView;
        this.modelType = BlackJackTableModel;
        this.windowPrefabResPath = 'package/blackjack/blackjack_table'
    }
   
    getRemoteRule(): string {
        return ""
    }

    
    onShow(intentData){
         // this.getRemoteRule = function(){
        //     return '{"playerCount":3}'
        // }
        if(this.mLogic){
            this.mLogic.reset()
        }
        this.model.init(GameServer.instance.netClient)
        // this.model.clearMsgEvent()
        this.mLogic = new BlackJackTableLogic(this, this.view, this.model)
        super.onShow(intentData)
        this.mLogic.onInit(intentData)
        this.mLogic.onShow(intentData)
        
        this.registNetMsg()
        this.eventBind("event_exit_game",()=>{
            this.mLogic.quitBtnOnClick()
        }); //
        
        
    }

    registNetMsg(){
        
        cc.log("registNetMsg")
        let self = this
        //进入房间
        self.model.subscibeMsgEvent<ProtoPokerRoom.Room.EnterRsp>(NetMsgDataTableBase.EnterRoom, function(protoData){

        })
        
        //进入房间 信息
        self.model.subscibeMsgEvent<BlackJack.GameInfo>(NetMsgBlackJack.GameInfo, function(protoData){
            self.mLogic.onNetMsgGameInfo(protoData)
        })


        //下注通知
        self.model.subscibeMsgEvent<BlackJack.BetNotify>(NetMsgBlackJack.BetNotify, function(protoData){
            self.mLogic.onNetMsgBetNotify(protoData)
        })

        //落座 旁观通知 OccupySeatNotify
        self.model.subscibeMsgEvent<BlackJack.OccupySeatNotify>(NetMsgBlackJack.OccupySeatNotify, function(protoData){
            self.mLogic.onNetMsgOccupySeatNotify(protoData)
        })

        //落座回复
        self.model.subscibeMsgEvent<BlackJack.OccupySeatRsp>(NetMsgBlackJack.OccupySeat, function(protoData){
            self.mLogic.onNetMsgOccupySeatRsp(protoData)
        })

        //发牌通知
        self.model.subscibeMsgEvent<BlackJack.DealCardNotify>(NetMsgBlackJack.DealCardNotify, function(protoData){
            self.mLogic.onNetMsgDealCardNotify(protoData)
        })

        //双倍通知 DoubleBetNotify
        self.model.subscibeMsgEvent<BlackJack.DoubleBetNotify>(NetMsgBlackJack.DoubleBetNotify, function(protoData){
            self.mLogic.onNetMsgDoubleBetNotify(protoData)
        })

        //分牌通知 EnableRightNotify
        self.model.subscibeMsgEvent<BlackJack.EnableRightNotify>(NetMsgBlackJack.EnableRightNotify, function(protoData){
            self.mLogic.onNetMsgEnableRightNotify(protoData)
        })

        //要牌通知 MoreCardNotify
        self.model.subscibeMsgEvent<BlackJack.MoreCardNotify>(NetMsgBlackJack.MoreCardNotify, function(protoData){
            self.mLogic.onNetMsgMoreCardNotify(protoData)
        })

        //停牌通知 NoMoreCardNotify
        self.model.subscibeMsgEvent<BlackJack.NoMoreCardNotify>(NetMsgBlackJack.NoMoreCardNotify, function(protoData){
            self.mLogic.onNetMsgNoMoreCardNotify(protoData)
        })

        //保险通知 InsuranceNotify
        self.model.subscibeMsgEvent<BlackJack.InsuranceNotify>(NetMsgBlackJack.InsuranceNotify, function(protoData){
            self.mLogic.onNetMsgInsuranceNotify(protoData)
        })


        //结算 GameSettle
        self.model.subscibeMsgEvent<BlackJack.GameSettle>(NetMsgBlackJack.GameSettle, function(protoData){
            self.mLogic.onNetMsgGameSettle(protoData)
        })
        
        //倒计时通知 TimeoutNotify
        self.model.subscibeMsgEvent<BlackJack.TimeoutNotify>(NetMsgBlackJack.TimeoutNotify, function(protoData){
            self.mLogic.onNetMsgTimeoutNotify(protoData)
            
        })

        //离开房间申请
        self.model.subscibeMsgEvent<Room.LeaveRsp>(NetMsgBlackJack.LeaveRoom, function(protoData){
            
        })
        

        //离开房间通知
        self.model.subscibeMsgEvent<Room.LeaveBroadcast>(NetMsgBlackJack.LeaveRoomNotify, function(protoData){
            
            self.mLogic.onNetMsgLeaveBroadcast(protoData)
        })

        //庄家发牌
        self.model.subscibeMsgEvent<BlackJack.BankerDealCardNotify>(NetMsgBlackJack.BankerDealCardNotify, function(protoData){
            self.mLogic.onNetMsgBankerDealCardNotify(protoData)
        })
        //下注回复
        self.model.subscibeMsgEvent<BlackJack.BetRsp>(NetMsgBlackJack.BetChip, function(protoData){
            self.mLogic.onNetMsgBetRsp(protoData)
        })
        //双倍回复
        self.model.subscibeMsgEvent<BlackJack.DoubleBetRsp>(NetMsgBlackJack.DoubleBet, function(protoData){
            self.mLogic.onNetMsgDoubleBetRsp(protoData)
        })

        //保险回复
        self.model.subscibeMsgEvent<BlackJack.InsuranceRsp>(NetMsgBlackJack.Insurance, function(protoData){
            self.mLogic.onNetMsgInsuranceRsp(protoData)
        })

        //停牌回复
        self.model.subscibeMsgEvent<BlackJack.NoMoreCardRsp>(NetMsgBlackJack.NoMoreCard, function(protoData){
            self.mLogic.onNetMsgNoMoreCardRsp(protoData)
        })

        //要牌回复
        self.model.subscibeMsgEvent<BlackJack.MoreCardRsp>(NetMsgBlackJack.MoreCard, function(protoData){
            self.mLogic.onNetMsgMoreCardRsp(protoData)
        })

        //分牌回复
        self.model.subscibeMsgEvent<BlackJack.EnableRightRsp>(NetMsgBlackJack.EnableRight, function(protoData){
            self.mLogic.onNetMsgEnableRightRsp(protoData)
        })

        //未下注提醒
        self.model.subscibeMsgEvent<BlackJack.NoBetNotify>(NetMsgBlackJack.NoBetNotify, function(protoData){
            self.mLogic.onNetMsgNoBetNotify(protoData)
        })

        //下注完成申请
        self.model.subscibeMsgEvent<BlackJack.BetFinishRsp>(NetMsgBlackJack.BetFinish, function(protoData){
            self.mLogic.onNetMsgBetFinishRsp(protoData)
        })

        //下注完成通知
        self.model.subscibeMsgEvent<BlackJack.BetFinishNotify>(NetMsgBlackJack.BetFinishNotify, function(protoData){
            self.mLogic.onNetMsgBetFinishNotify(protoData)
        })
    }
    on_destroy(){
        super.on_destroy()
       
    }
    getSeatNodeById(playerId:number)
    {
        return this.view.getSeatNodeById(playerId)
    }
    
   

    protected onUserCoinBalanceNotify(data: {playerId: number, coinBalance: number}){
        super.onUserCoinBalanceNotify(data);
        this.mLogic.onUserCoinBalanceNotify(data);
    }

    

    
}